import { Grid } from '@mui/material';
import BlockProps from '../../../models/BlockProps';
import Utils from '../../../utils/Utils';
import CloseButton from '../../Buttons/Close';
import EditableText from '../../Form/EditableText';
import BlockTitleData from './BlockTitleData';

function BlockTitle({
  data, isEditing, isTemplate, editHandler,
}: BlockProps) {
  const props = (data.data as BlockTitleData);

  const handleUpdate = (text: string) => {
    props.title.value = text;
    editHandler(data.id, props);
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: 120,
        overflow: 'hidden',
      }}
    >

      {props.title && (
        <Grid item sx={Utils.hoverBorder(isEditing)}>
          <CloseButton
            show={isEditing}
            updateHandler={() => {
              props.title = undefined;
              editHandler(data.id, props);
            }}
          />
          <EditableText
            text={props.title.value}
            isEditable={isEditing && !isTemplate}
            updateHandler={handleUpdate}
          />
        </Grid>
      )}

    </Grid>
  );
}

export default BlockTitle;
